import { Box, FormControl, InputLabel, MenuItem } from "@mui/material";
import React from "react";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";

const Verifyresidentialaddress = () => {
  const [documentType, setDocumentType] = React.useState("");
  const navigate = useNavigate();

  const handleNavigation = (event) => {
    const selectedValue = event.target.value;
    setDocumentType(selectedValue);

    // Trigger navigation based on the selected value
    if (selectedValue === 10) {
      navigate("/VerifyresidentialForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Electricity Bills page
    } else if (selectedValue === 20) {
      navigate("/VerifyresidentialForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Water Bills page
    } else if (selectedValue === 30) {
      navigate("/VerifyresidentialForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Gas Bills page
    } else if (selectedValue === 40) {
      navigate("/VerifyresidentialForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Rental Agreement page
    } else if (selectedValue === 50) {
      navigate("/VerifyresidentialForm", {
        state: { documentType: selectedValue },
      }); // Navigate to Bank Statement page
    }
  };

  return (
    <div className="Allcards_full_container p-3">
      <div className=" bg-white p-2 rounded-2">
        <div
          className="d-flex flex-column justify-content-center align-items-center text-center "
          style={{
            minHeight: "80vh", // Full viewport height
          }}
        >
          <div>
            <h2 className="m-0">Verify Your Residential Address Identity</h2>
            <p className="paragraph my-1">
              Upload Your Residential Address for Secure Verification
            </p>
          </div>

          <Box>
            <FormControl sx={{ minWidth: 400 }}>
              <InputLabel id="demo-simple-select-label">
                Select Document type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={documentType}
                label="Select Document type"
                onChange={handleNavigation}
              >
                {/* Placeholder MenuItem */}

                <MenuItem value={10}>Electricity Bills</MenuItem>
                <MenuItem value={20}>Water Bills</MenuItem>
                <MenuItem value={30}>Gas Bills</MenuItem>
                <MenuItem value={40}>Rental Agreement</MenuItem>
                <MenuItem value={50}>Bank Statement</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Verifyresidentialaddress;
